angular
  .module('contrast.factory.attack', [])
  .factory('AttackFactory', function ($http, $q, UserService) {
    return {
      getAttacks: function (filters) {
        var httpTimeout = $q.defer(),
          request = $http({
            method: 'post',
            url: UserService.buildAPIUrl('/attacks'),
            params: filters.params,
            data: filters.data,
            timeout: httpTimeout.promise
          })

        request._httpTimeout = httpTimeout
        return request
      },
      getAttacksUUIDs: function (filters) {
        var httpTimeout = $q.defer(),
          request = $http({
            method: 'post',
            url: UserService.buildAPIUrl('/attacks/ids'),
            params: filters.params,
            data: filters.data,
            timeout: httpTimeout.promise
          })

        var promise = request.then()
        promise._httpTimeout = httpTimeout
        return promise
      },
      getAttack: function (attackUuid) {
        return $http.get(UserService.buildAPIUrl('/attacks/' + attackUuid))
      },
      getActiveAttacksSummary: function () {
        return $http.get(UserService.buildAPIUrl('/attacks/active'))
      },
      getAttackExpand: function (attackUuid, expandValue) {
        return $http.get(UserService.buildAPIUrl('/attacks/' + attackUuid), {
          params: { expand: expandValue }
        })
      },
      suppress: function (attackUuid) {
        return $http.put(
          UserService.buildAPIUrl('/attacks/' + attackUuid + '/suppress')
        )
      },
      suppressBatch: function (attacks) {
        var self = this
        return self.batchExecution(attacks, self.suppress)
      },
      batchExecution: function (attacks, method) {
        var promises = []

        angular.forEach(attacks, function (attacks) {
          var defer = $q.defer()
          method(attacks.uuid).then(
            function (response) {
              defer.resolve({ success: true, response: response })
            },
            function (response) {
              defer.resolve({ success: false, response: response })
            }
          )
          promises.push(defer.promise)
        })

        return $q.all(promises)
      },
      getAttackQuickFilters: function (filters) {
        var httpTimeout = $q.defer(),
          request = $http({
            method: 'post',
            url: UserService.buildAPIUrl('/attacks/filters/quick'),
            data: filters,
            timeout: httpTimeout.promise
          })

        request._httpTimeout = httpTimeout
        return request
      },
      getFiltersCatalogs: function () {
        return $http.get(UserService.buildAPIUrl('/attacks/filters/listing'))
      },
      getFiltersByType: function (type, filters) {
        var httpTimeout = $q.defer(),
          request = $http({
            method: 'post',
            url: UserService.buildAPIUrl(
              '/attacks/filters/' + type + '/listing'
            ),
            data: filters,
            timeout: httpTimeout.promise
          })

        request._httpTimeout = httpTimeout
        return request
      },
      getNotes: function (attackUuid) {
        return $http.get(
          UserService.buildAPIUrl('/attacks/notes/' + attackUuid)
        )
      },
      addNote: function (attackUuid, note) {
        return $http.post(
          UserService.buildAPIUrl('/attacks/notes/' + attackUuid),
          { note: note }
        )
      },
      editNote: function (attackUuid, noteId, note) {
        return $http.put(
          UserService.buildAPIUrl(
            '/attacks/notes/' + attackUuid + '/' + noteId
          ),
          { note: note }
        )
      },
      deleteNote: function (attackUuid, noteId) {
        return $http['delete'](
          UserService.buildAPIUrl('/attacks/notes/' + attackUuid + '/' + noteId)
        )
      },
      countUnreadNotes: function (attackUuid) {
        return $http.get(
          UserService.buildAPIUrl('/attacks/notes/' + attackUuid + '/unread')
        )
      },
      updateLastViewed: function (attackUuid) {
        return $http.put(
          UserService.buildAPIUrl('/attacks/notes/' + attackUuid + '/view')
        )
      }
    }
  })
